import React from 'react'

export type TierItem = {
    displayName: string;
    internalName: string;
    roundName: string;
    isRepBody: boolean;
    tierValue: number;
    maximumAnnualTurnover: number | null;
    minimumAnnualTurnover: number | null;

    openingDate: string | null;
    openingDateUTC: string | null;
    closingDate: string | null;
    closingDateUTC: string | null;

    sortOrder: number;
};

// Create a Context object
export const GlobalDataContext = React.createContext({
  tierSettingsArr: null as (TierItem[] | null),
  // eslint-disable-next-line no-unused-vars
  refreshTierData: (_data: TierItem[]) => { },
})
